/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useHistory } from 'react-router';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { PostContentsToHTML } from '../components/PostContentsToHTML';
import { IconArrowBack } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { feedPreferencesHelpText } from '../markdownPages/FeedPreferencesHelpText';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
export const AboutAlgorithm: React.FC = () => {
	const history = useHistory();
	return (
		<QuirkIonPage roles={['anonymous', 'user']} name="About Algorithm">
			<Header title="logo" left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />} />
			<QuirkIonContent>
				<div className={sharedStyles.contentWrapper}>
					<PostContentsToHTML>{feedPreferencesHelpText}</PostContentsToHTML>
				</div>
			</QuirkIonContent>
		</QuirkIonPage>
	);
};
